import { useContext } from "react";
import { StyleSheet, View, Text, ImageBackground, Image } from "react-native";
import {
  DrawerContentScrollView,
  DrawerItemList,
} from "@react-navigation/drawer";
//import Ionicons from "react-native-vector-icons/Ionicons";
import { Ionicons } from "./VectorIcons";
//import FontAwesome5 from "react-native-vector-icons/FontAwesome5";
import SimplePress from "./SimplePress";
import { AuthContext } from "../context/AuthContext";
import { NotifyContext } from "./Notification";
import { getSchemeStyle } from "../context/helper";

const showNotificationTest = false;

const CustomDrawer = (props) => {
  const schemeStyles = getSchemeStyle();

  const { logout, changeFirm, userInfo } = useContext(AuthContext);
  const { testNotification } = useContext(NotifyContext);

  return (
    /*         <ImageBackground
          source={require("../assets/images/menu-bg.jpeg")}
          style={styles.bgImage}
        >
          <Image
            source={require("../assets/images/user-profile.jpg")}
            style={styles.userImage}
          />
          <Text style={styles.userText}>John Doe</Text>
          <View style={styles.userInfoContainer}>
            <Text style={styles.userInfo}>280 Coins</Text>
            <FontAwesome5 name="coins" size={14} color={"#fff"} />
          </View>
        </ImageBackground>
 */ <View style={styles.mainContainer}>
      <DrawerContentScrollView
        {...props}
        contentContainerStyle={styles.drawerContainer}
      >
        <View style={[styles.drawerItemContainer,schemeStyles.Background]}>
          <DrawerItemList {...props} />
        </View>
      </DrawerContentScrollView>
      <View style={[styles.footContainer,schemeStyles.Background,schemeStyles.Border]}>
        {userInfo.current.loginname !== "TestUser" && (
          <SimplePress
            onPress={() => {
              props.navigation.closeDrawer();
              //props.navigation.navigate("ChangePassword", { showBack: true });
              props.navigation.navigate("ChangePassword2", {
                screen: "ChangePassword",
                params: { showBack: true },
              });
            }}
            style={styles.footItem}
          >
            <Ionicons name="lock-closed-outline" size={22} color={schemeStyles.Drawer.inactiveTintColor} />
            <Text style={[styles.footText,schemeStyles.drawerCustomText]}>Kennwort ändern</Text>
          </SimplePress>
        )}
        {(userInfo.current.R_Admin || userInfo.current.R_Manager) && (
          <SimplePress
            onPress={() => {
              changeFirm();
            }}
            style={styles.footItem}
          >
            <Ionicons name="list-outline" size={22} color={schemeStyles.Drawer.inactiveTintColor} />
            <Text style={[styles.footText,schemeStyles.drawerCustomText]}>Firma wechseln</Text>
          </SimplePress>
        )}
        {showNotificationTest && (
          <SimplePress
            onPress={() => {
              testNotification(false);
            }}
            style={styles.footItem}
          >
            <Ionicons name="exit-outline" size={22} color={schemeStyles.Drawer.inactiveTintColor} />
            <Text style={[styles.footText,schemeStyles.drawerCustomText]}>Notify Test Sound</Text>
          </SimplePress>
        )}
        {showNotificationTest && (
          <SimplePress
            onPress={() => {
              testNotification(true);
            }}
            style={styles.footItem}
          >
            <Ionicons name="exit-outline" size={22} color={schemeStyles.Drawer.inactiveTintColor} />
            <Text style={[styles.footText,schemeStyles.drawerCustomText]}>Notify Test Mute</Text>
          </SimplePress>
        )}
        <SimplePress
          onPress={() => {
            logout();
          }}
          style={styles.footItem}
        >
          <Ionicons name="exit-outline" size={22} color={schemeStyles.Drawer.inactiveTintColor} />
          <Text style={[styles.footText,schemeStyles.drawerCustomText]}>Abmelden</Text>
        </SimplePress>
      </View>
    </View>
  );
};

export default CustomDrawer;

const styles = StyleSheet.create({
  mainContainer: {
    flex: 1,
  },
  drawerContainer: {
    backgroundColor: "#315e83",
    flex: 1,
  },
  drawerItemContainer: {
    flex: 1,
    paddingTop: 10,
  },
  footContainer: {
    padding: 20,
    borderTopWidth: 1,
  },
  footItem: {
    paddingVertical: 15,
    flexDirection: "row",
    alignItems: "center",
  },
  footText: {
    marginLeft: 5,
    fontSize: 15,
    fontFamily: "Roboto-Medium",
  },
});
